import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    const countryDisclosureEl = section.el.querySelector('[data-disclosure-country]');
    const localeDisclosureEl = section.el.querySelector('[data-disclosure-locale]');

    if (countryDisclosureEl) {
      this.countryDisclosure = new Disclosure(countryDisclosureEl);
    }

    if (localeDisclosureEl) {
      this.localeDisclosure = new Disclosure(localeDisclosureEl);
    }
  }

  onSectionUnload() {
    if (this.countryDisclosure) {
      this.countryDisclosure.unload();
    }

    if (this.localeDisclosure) {
      this.localeDisclosure.unload();
    }
  }
}
